import { initAddressAutocomplete } from "./forms/addressAutocomplete";
import { initPhoneInput } from "./forms/phone";

export function initAccountDeliveryForm(): void {
    const form = document.querySelector<HTMLFormElement>("[data-account-delivery-form]");
    if (!form) return;

    const country = form.querySelector<HTMLSelectElement>("[data-address-country]");
    const visiblePhone = form.querySelector<HTMLInputElement>("[data-phone-visible]");
    const hiddenPhone = form.querySelector<HTMLInputElement>("[data-phone-hidden]");

    const phone = country && visiblePhone && hiddenPhone
        ? initPhoneInput(visiblePhone, hiddenPhone, country)
        : null;

    form.addEventListener("submit", event => {
        if (phone?.validate()) return;

        event.preventDefault();
        visiblePhone?.focus();
    });

    initAddressAutocomplete(form);
}
